import { useMutation } from 'react-query';
import { authFetch } from '../../../../../CommonUtils/authFetch';

interface Response {
  AuthUrl: string;
  ContextId: string;
}

const fetchExternalAccountProviderAuthUrl = (url: string): Promise<Response> => {
  return authFetch(url);
};

export const useExternalAccountProviderAuthUrlMutation = () => {
  return useMutation(fetchExternalAccountProviderAuthUrl);
};
